export class Chart {
    public lineChartData: Array<any> = [{ data: [], label: '' }]
    public lineChartLabels: Array<any> = []
    public lineChartOptions: any = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        legend: {
            display: false,
            labels: {
                fontSize: 14,
                filter: function (legendItem, chartData) {
                    return legendItem.text !== ''
                }
            }
        },
        tooltips: {
            enabled: false,
            mode: 'nearest',
            intersect: true,
            custom: function (tooltipModel) {
                // Get or create tooltip element
                var tooltipElement: any = document.getElementById('rento-tooltip');
                if (!tooltipElement) {
                    tooltipElement = document.createElement('div');
                    tooltipElement.id = 'rento-tooltip';
                    tooltipElement.classList.add('chartjs-tooltip');
                    tooltipElement.innerHTML = '<table></table>';
                    this._chart.canvas.parentNode.appendChild(tooltipElement);
                }

                if (tooltipModel.opacity === 0) {
                    tooltipElement.style.opacity = 0;
                    return;
                }

                if (!tooltipModel || !tooltipModel.dataPoints || tooltipModel.dataPoints.length === 0) {
                    tooltipElement.style.opacity = 0;
                    return;
                }
                var index = tooltipModel.dataPoints[0].index
                if (index === undefined || index < 0) {
                    tooltipElement.style.opacity = 0;
                    return;
                }

                var tooltipValues = []
                for (var i = 0; i < this._data.datasets.length; i++) {
                    var dataset = this._data.datasets[i]
                    // yAxisID is set in details component
                    if (dataset && dataset.yAxisID === 'A') {
                        tooltipValues.push({
                            label: dataset.label,
                            value: dataset.data[index]
                        });
                    }
                }

                // Use table element for tooltip
                var tableHtml = '<thead><tr><th>' + tooltipModel.title[0] + '</th></tr></thead>';
                tableHtml += '<tbody>';
                tooltipValues.forEach(tip => {
                    tableHtml += '<tr><td>' + tip.label + '</td><td style="text-align: right;">' + tip.value + '</td></tr>'
                })
                tableHtml += '</tbody>';
                var tableElement = tooltipElement.querySelector('table');
                tableElement.innerHTML = tableHtml;

                // Calculate position based on hovered point, flip tooltip position at edges
                var positionY = this._chart.canvas.offsetTop + 5;
                var positionX = this._chart.canvas.offsetLeft;
                var xAlign = -1 * (tooltipElement.offsetWidth / 2) - 5;
                tooltipElement.style.opacity = 1;
                var left = positionX + xAlign + tooltipModel.caretX
                if (left < tooltipElement.offsetWidth) {
                    left = positionX + tooltipModel.caretX + (tooltipElement.offsetWidth / 2) + 5
                }
                var top = positionY + tooltipModel.caretY
                if (top > (this._chart.canvas.height - tooltipElement.offsetHeight)) {
                    top = positionY + tooltipModel.caretY - tooltipElement.offsetHeight - 10;
                }
                tooltipElement.style.left = left + 'px';
                tooltipElement.style.top = top + 'px';
                tooltipElement.style.font = 'normal 12px sans-serif';
                tooltipElement.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
            }
        },
        scales: {
            yAxes: [
                {
                    id: 'A',
                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        max: 160
                        // suggestedMax: 140
                    }
                },
                {
                    id: 'B',
                    position: 'right',
                    ticks: {
                        beginAtZero: true,
                        min: 0,
                        max: 160
                        // suggestedMax: 140
                    }
                }
            ],
            xAxes: [{
                ticks: {
                    autoSkip: true,
                    display: true,
                    autoSkipPadding: 5
                },
                gridLines: {
                    color: 'rgba(0,0,0,0)'
                }
            }]
        }
    }
    public lineChartLegend: boolean = true
    public lineChartType: string = 'line'
    public lineChartColors: Array<any> = [
        this.createColors(100, 255, 100, 0),    // noise
        this.createColors(5, 100, 255, 0.3),    // humidity
        this.createColors(220, 80, 75, 0.3),    // temperature
        this.createColors(255, 191, 31, 0.3),   // index
        this.invisibleColors()                  // hack, used by the seconds y-axis on the right side of chart
    ]

    private createColors(red: number, green: number, blue: number, alpha: number): any {
        let divider: number = 1.5
        let pointAlpha: number = 0.0
        let pointBorderAlpha: number = 0.0
        let dRed: number = Math.round((red / divider))
        let dGreen: number = Math.round((green / divider))
        let dBlue: number = Math.round((blue / divider))
        return {
            backgroundColor: 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + alpha + ')',
            borderColor: 'rgba(' + dRed + ', ' + dGreen + ', ' + dBlue + ', 1.0)',
            pointBackgroundColor: 'rgba(' + red + ', ' + green + ', ' + blue + ', ' + pointAlpha + ')',
            pointBorderColor: 'rgba(' + dRed + ', ' + dGreen + ', ' + dBlue + ', ' + pointBorderAlpha + ')',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        }
    }

    private invisibleColors() {
        return {
            backgroundColor: 'rgba(0,0,0,0)',
            borderColor: 'rgba(0,0,0,0)',
            pointBackgroundColor: 'rgba(0,0,0,0)',
            pointBorderColor: 'rgba(0,0,0,0)',
            pointHoverBackgroundColor: 'rgba(0,0,0,0)',
            pointHoverBorderColor: 'rgba(0,0,0,0)'
        }
    }
}



// WEBPACK FOOTER //
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/device/details/chart.model.ts